<template>
      <v-card hover flat>
        <v-form ref="form" v-model="valid" lazy-validation enctype="multipart/form-data">
          <v-card-title>
            <h3 class="headline mb-0"><span style="color: #0D47A0">FAC. {{ this.datos.status }}: {{  this.datos.id }} </span></h3>
          </v-card-title>
          <v-card-text>
                <v-flex xs12 align-center justify-space-between>
                    <v-layout align-center>
                        {{ this.datos.payments ? this.datos.payments.length != 0 ? 'Pagos realizados: ' + this.datos.payments.length : 'No se han realizado pagos' : '' }}
                    </v-layout>
                </v-flex>
                <v-expansion-panel>
                    <v-expansion-panel-content v-for="(pay, key) in this.datos.payments" :key="pay.id">
                        <template v-slot:actions>
                            <v-icon color="primary">{{ pay[key] ? 'done' : 'error' }}</v-icon>
                        </template>

                        <template v-slot:header>
                            <div>Pago {{ (key + 1) }}</div>
                        </template>

                        <v-card>
                            <v-card-text class="grey lighten-3">
                                <v-text-field
                                    v-if="pay.way_to_pay == 'PUNTO ELECTRONICO' || pay.way_to_pay == 'TRANSFERENCIA'"
                                    readonly
                                    prepend-icon="account_balance"
                                    v-model=pay.bank.name
                                    label="Banco"
                                ></v-text-field>

                                <v-flex xs12 align-center justify-space-between>
                                    <v-layout align-center>

                                        <v-flex xs12 md4>
                                            <v-text-field
                                                readonly
                                                prepend-icon="payment"
                                                v-model="pay.way_to_pay"
                                                label="Metodo de Pago"
                                            ></v-text-field>
                                        </v-flex>

                                        <v-flex xs12 md4>
                                            <v-text-field
                                                readonly
                                                prepend-icon="drag_handle"
                                                v-model="pay.number"
                                                label="Numero Transaccion"
                                            ></v-text-field>
                                        </v-flex>

                                         <v-flex xs12 md4>
                                            <v-text-field
                                                readonly
                                                prepend-icon="event"
                                                v-model="pay.payment_date"
                                                label="Fecha Transacción"
                                            ></v-text-field>
                                        </v-flex>

                                    </v-layout>
                                </v-flex>

                                <v-flex xs12>
                                    <v-text-field
                                        readonly
                                        prepend-icon="account_balance_wallet"
                                        v-model="pay.amount"
                                        label="Ingrese Monto Pagado"
                                    ></v-text-field>
                                </v-flex>

                                <v-text-field
                                    readonly
                                    prepend-icon="insert_comment"
                                    v-model="pay.observations"
                                    label="Observaciones"
                                ></v-text-field>

                                <v-flex xs12 align-center justify-center layout text-xs-center>
                                    <v-btn color="primary" :href="`/storage/documents/pagos/${pay.src}`" target="_blank">
                                        VER DOCUMENTO
                                    </v-btn>
                                </v-flex>
                            </v-card-text>
                            <v-card-actions align-center class="grey lighten-3" v-if="!pay.agreement">
                                <v-btn :loading="loading" class="error" @click="eliminarPago(pay,key)"><v-icon>delete</v-icon></v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-expansion-panel-content>
                </v-expansion-panel>
          </v-card-text>

          <v-card-actions>
            <v-btn @click="cerrarDialog(null)">Cerrar</v-btn>
          </v-card-actions>

        </v-form>


      </v-card>
</template>

<script>
import axios from 'axios'
import Form from 'vform'


Number.prototype.toFixedDown = function(digits) {
    var re = new RegExp("(\\d+\\.\\d{" + digits + "})(\\d)"),
        m = this.toString().match(re);
    return m ? parseFloat(m[1]) : this.valueOf();
};

export default {
    
    name: 'form-invoice-status-view',

    props: {
        loading: {
            type: Boolean,
            required: true
        },
        datos: {
            type: Object,
            required: true
        },
        iscuentascobrar: {
            type: Boolean,
            default: false
        }
    },

    watch: {
        datos(v) {
            this.$refs.form.resetValidation()
            
            v.payments.forEach(function(value, index) {
                v.payments[index].existepay = []
                v.payments_unionize.forEach(pu => {
                    if(value.number == pu.number && value.bank_id == pu.bank_id && pu.agreement && value.id != pu.id){
                        v.payments[index].existepay.push(pu)
                    }
                })
            })

            this.form = {
                id: v.id,
                rif: v.rif,
                direccion_fiscal: v.direccion_fiscal,
                razon_social: v.razon_social,
                status: v.status,
                payments: v.payments,
                amount: v.amount,
                payment_date2: new Date().toISOString().slice(0,10)
            }
        }
    },

    computed: {
        computedDateFormattedFecha () {
            return this.formatDate(this.form.payment_date2)
        }
    },


  data: () => ({
    valid: false,
    dialogAnulacion: false,
    status: ['PAGADO','PENDIENTE','ANULADO'],
    formAnulacion: new Form({
        motivo_anulacion: '',
    }),
    date: null,
    fecha: null,
    menu: false,
    form: new Form({
        id: '',
        pay_id: '',
        payments: [],
        rif: '',
        bank_id: '',
        unionize_cpc: '',
        direccion_fiscal: '',
        razon_social: '',
        way_to_pay: '',
        status: '',
        number: '',
        payment_date: '',
        payment_date2: '',
        observations: '',
        src: '',
        amount: ''
    })
  }),

  mounted() {
    this.$store.dispatch('clearMessage')
  },

  methods: {

    formatDate (date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
    },
    
    async eliminarPago (pago) {
        this.$emit('responseLoading', true)
        let confirmDelete = confirm('Seguro que desea eliminar el registro del pago?')
          if (confirmDelete) {
            await axios.delete('/api/payments/admin/' + pago.id)
            .then(response => {
                this.$store.dispatch('responseMessage', {
                    type: 'error',
                    text: `Pago eliminado`
                })
                this.cerrarDialog(response)
            }).catch(error => {
                console.log(error.response)
            }).finally(() => this.$emit('responseLoading', false))
          }
    },
    

    changeInfo (data) {
        console.log(data)
    },

    cerrarDialog (data) {
        this.$emit('closeDialogInvoiceStatus', data)
        this.$nextTick(() => {
            this.$refs.form.resetValidation()
            this.$emit('responseLoading', false)
        })
    },


    async changeStatusConciliacion (status) {
        this.$emit('responseLoading', true)
        await axios.post('/api/administration/cobranza/conciliacion-change-status',{ id: this.form.id, status: status, motivo_anulacion: this.formAnulacion.motivo_anulacion }).then((resp) => {
            console.log(resp,'resp')
            this.form.status = status
            this.$store.dispatch('responseMessage', {
                type: 'success',
                text: `Cambio de estatus a ${status} exitoso`
            })
            this.cerrarDialog(resp)
        }).catch((error) => {
            console.log(error.response)
            if(error.response){
                if(error.response.status == 404){
                    this.$store.dispatch('responseMessage', {
                        type: 'error',
                        text: 'No se encontro la factura, intente nuevamente.'
                    })   
                }else if(error.response.status == 403) {
                    this.$store.dispatch('responseMessage', {
                        type: 'error',
                        text: 'No es posible actualizar esta factura.'
                    })  
                }
            } else {
                console.log('Error', error.message);
            }
        }).finally(() => this.$emit('responseLoading', false))
    }

  }

}
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/cobranza/formInvoiceSolicitudStatus.vue